
import React from 'react';
import { useYouTubeAuth } from './hooks/useYouTubeAuth';
import { LoadingView, SuccessView, ErrorView } from './StatusViews';
import YouTubeChannelSelection from '@/components/dashboard/profiles/youtube/YouTubeChannelSelection';

const YouTubeAuthCallback = () => {
  const {
    isLoading,
    error,
    success,
    debugInfo,
    showChannelSelection,
    channels,
    userEmail,
    isSyncing,
    handleSelectChannel,
    handleCancel,
    handleRetry
  } = useYouTubeAuth();
  
  if (showChannelSelection && !isLoading && !success && !error) {
    return (
      <div className="container max-w-4xl mx-auto p-4">
        <YouTubeChannelSelection
          channels={channels}
          email={userEmail}
          onSelectChannel={handleSelectChannel}
          onCancel={handleCancel}
          isLoading={isLoading || isSyncing}
        />
      </div>
    );
  }
  
  return (
    <div className="container max-w-xl mx-auto p-4">
      <div className="bg-white rounded-lg shadow-sm p-6">
        {isLoading || isSyncing ? (
          <LoadingView debugInfo={debugInfo} />
        ) : error ? (
          <ErrorView 
            errorMessage={error} 
            debugInfo={debugInfo}
            handleRetry={handleRetry}
          />
        ) : success ? (
          <SuccessView />
        ) : null}
      </div>
    </div>
  );
};

export default YouTubeAuthCallback;
